// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8257) return "static/chunks/8257-49fbc2391d702174.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1996":"1619b349d721f3b0","2728":"927bef593c6a3437","8686":"ad89002376245d2d","8918":"4f6ff19588541daa"}[chunkId] + ".js";
};